import React     from 'react';
import PropTypes from 'prop-types';
import uniqueId  from 'lodash.uniqueid';

class FormCheckbox extends React.PureComponent {

	constructor(props) {
		super(props);

		// properties
		this.inputElement = null;
		this.checkboxId   = uniqueId('form-checkbox-');

		// bind handlers to this
		this.handleInputChange = this.handleInputChange.bind(this);
	}

	handleInputChange() {
		if (typeof this.props.onValueChange === 'function') {
			this.props.onValueChange(
				this.inputElement.checked,
				this.props.name
			);
		}
	}

	render() {
		// default values
		const label               = this.props.label || '';
		const sizeClassName       = this.props.size ? '-size-' + this.props.size : '';
		const extraLabelClassName = this.props.labelClassName ? (' ' + this.props.labelClassName) : '';

		// css classes
		const checkboxClassName = 'form__checkbox__checkbox ' + sizeClassName + (this.props.checked ? ' checked' : '') + (this.props.noMargin ? ' form__checkbox__checkbox--no-margin' : '');
		const labelClassName    = 'form__label ' + sizeClassName + extraLabelClassName;

		return (
			<div className={"form__checkbox" + (this.props.noMargin ? ' form__checkbox--no-margin' : '')}>
				<input
					type="checkbox"
					id={this.checkboxId}
					name={this.props.name}
					onChange={this.handleInputChange}
					checked={this.props.checked}
					ref={(input) => this.inputElement = input}
				/>
				<label className={labelClassName} htmlFor={this.checkboxId}>
					<span className={checkboxClassName} />
					<span className="form__checkbox__label">{label}</span>
				</label>
			</div>
		);
	}
}

FormCheckbox.propTypes = {
	name:           PropTypes.string,
	label:          PropTypes.string,
	checked:        PropTypes.bool,
	onValueChange:  PropTypes.func,
	size:           PropTypes.string,
	labelClassName: PropTypes.string,
	noMargin:       PropTypes.bool,
};

export default FormCheckbox;
